import React from "react";
import { ReportsStatusTypes } from "pages/Dashboards/OnlineDashboard/types";
import { statusTypes } from "./types";
import { getReportsStatusDataArray } from "./utils";
import "../styles.scss";

type Props = {
  data: ReportsStatusTypes;
};

const ReportsStatus = ({ data }: Props) => {
  const statuses: statusTypes[] = getReportsStatusDataArray(data);

  return (
    <div className="statuses-container">
      {statuses.map((status: statusTypes) => (
        <div
          key={`status-${status.title}`}
          className="status-container data-box"
        >
          <div className="inner-border dashed-inner-border">
            <div className="row-container">
              <p className="amount">{status.amount}</p>
              {status.icon}
            </div>
            <p className="status-title">{status.title}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ReportsStatus;
